import Panel from "./Panel.js"

export default class Quality extends Panel {

  constructor(props, context) {
    super(props, context)
    this.listOptions = [
      { label: "Auto", value: "0.25" } // TODO: Auto needs to be localized
    ]
    this.qualityLevels = []
    this.state.title = "Quality" // TODO: This needs to be localized
    this.state.activeIndex = -1
  }

  static get contextTypes() {
    return super.contextTypes
  }

  componentWillMount() {
    super.componentWillMount()
    this.onqualitylevelsloaded({detail: this.player.qualityLevels})
    this.onqualitychanging({detail: this.player.qualityLevels[this.player.quality]})
    this.open = true
  }

  clickHandler(object, index) {
    this.player.quality = index - 1
    if (!index)
      this.onqualitychanging()
  }

  onqualitylevelsloaded(event) {
    this.qualityLevels = event.detail
    this.qualityLevels.forEach((item) => {
      this.listOptions.push({"label": `${Math.round(item.bitrate / 1000)} Kbps`})
    })
    this.setState({redraw: true})
  }

  onqualitychanging(event) {
    let index = -1, autoLevel = false
    try {
      autoLevel = this.player.qualityMode
      index = autoLevel == "auto" ? -1 : (event.detail ? this.qualityLevels.findIndex(levelObject => levelObject.qualityIndex == event.detail.qualityIndex && levelObject.level == event.detail.level) : this.props.quality.quality)
    } catch (e) {}

    this.setState({activeIndex: index})
  }

  isOptionSelected(item, index) {
    return (index - 1 === this.state.activeIndex)
  }
}
